
import { common } from './common/fi';
import { products } from './products/fi';
import { pricing } from './pricing/fi';
import { solutions } from './solutions/fi';

export const fi = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
